<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <app-users-page />
    </div>
  </div>
</template>

<script>
import AppUsersPage from '../Components/AppUsersPage.vue';
export default {
    name: 'AppUsers',
    components: {
        'app-users-page': AppUsersPage,
    },
};
</script>
